import { useEffect, useRef, useState } from "react";

export type LeftConversation = { id: string; title: string };

type Args = {
  pageRequest: number | undefined;
  page: string;
  hasTurns: boolean;
  isRunning: boolean;
  isRestoring: boolean;
  openConversation: () => LeftConversation | null;
  startNew: () => void;
  bindToPage: () => void;
  onLeft: (conversation: LeftConversation | null) => void;
};

export const usePageRequestStartsConversation = ({
  pageRequest,
  page,
  hasTurns,
  isRunning,
  isRestoring,
  openConversation,
  startNew,
  bindToPage,
  onLeft,
}: Args): { startsNewWhenAnswered: boolean } => {
  const handled = useRef(0);
  const raisedOn = useRef<{ request: number; page: string } | null>(null);
  const [startsNewWhenAnswered, setStartsNewWhenAnswered] = useState(false);
  useEffect(() => {
    if (!pageRequest || pageRequest === handled.current) {
      setStartsNewWhenAnswered(false);
      return;
    }
    if (raisedOn.current?.request !== pageRequest) raisedOn.current = { request: pageRequest, page };
    if (raisedOn.current.page !== page) {
      handled.current = pageRequest;
      setStartsNewWhenAnswered(false);
      return;
    }
    if (isRunning || isRestoring) {
      setStartsNewWhenAnswered(isRunning && hasTurns);
      return;
    }
    handled.current = pageRequest;
    setStartsNewWhenAnswered(false);
    if (hasTurns) {
      onLeft(openConversation());
      startNew();
    }
    bindToPage();
  }, [pageRequest, page, hasTurns, isRunning, isRestoring, openConversation, startNew, bindToPage, onLeft]);
  return { startsNewWhenAnswered };
};
